import { Button } from "ui/button/button";
import { Panel } from "ui/panel/panel";
import { DEFAULT_CONFIRM_LABEL } from "ui/quick-tip/quick-tip.constants";
import { QuickTipIcon, QuickTipTitle } from "ui/quick-tip/quick-tip.styles";
import { type QuickTipProps } from "ui/quick-tip/quick-tip.types";

import Icons from "assets";

type QuickTipPanelProps = Pick<
  QuickTipProps,
  "title" | "body" | "showIcon" | "onClose" | "onConfirm" | "confirmLabel"
>;

/** What `QuickTip` puts in its popover — apart so the Docs figures can draw it on a static paper. */
export const QuickTipPanel = ({
  title,
  body,
  showIcon = true,
  onClose,
  onConfirm,
  confirmLabel = DEFAULT_CONFIRM_LABEL,
}: QuickTipPanelProps) => (
  <Panel
    title={
      <QuickTipTitle>
        {showIcon && <QuickTipIcon aria-hidden />}
        {title}
      </QuickTipTitle>
    }
    subtitle={body}
    onClose={onClose}
    divider={false}>
    {onConfirm && (
      <Button variant="contained" size="small" startIcon={<Icons.Checkmark />} onClick={onConfirm}>
        {confirmLabel}
      </Button>
    )}
  </Panel>
);
